import React from "react";
import css from "./integration.module.css";
import { NavLink } from "react-router-dom";
const IntegrationCard = ({data}) => {

    const {status, status_color, status_bg, icon, title, desc } = data

  return (
    <div className={css.integration_card}>
      <NavLink className={css.connect_btn}>
        <button style={{color: status_color, backgroundColor: status_bg}}>{status}</button>
      </NavLink>
      <div className={css.integration_icon}>
        <img
          src={icon}
          alt="DriveCard"
        />
      </div>
      <h3>{title}</h3>
      <p>
        {desc}        
      </p>
    </div>
  );
};

export default IntegrationCard;
